import React, { createContext, useContext, ReactNode } from 'react';

interface DashboardContextType {
  updateContent: (view: string, data?: any) => void;
  contentView: string;
  contentData?: any;
  previousContentView?: string | null;
  previousContentData?: any;
  restorePreviousContent: () => void;
}

const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

export const useDashboard = () => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error('useDashboard must be used within a DashboardProvider');
  }
  return context;
};

// Safe variant for components that may render outside a DashboardProvider (e.g., AppHeader).
// Returns null instead of throwing so hooks are always called unconditionally.
export const useDashboardSafe = () => {
  const context = useContext(DashboardContext);
  return context ?? null;
};

interface DashboardProviderProps {
  children: ReactNode;
  updateContent: (view: string, data?: any) => void;
  contentView: string;
  contentData?: any;
  previousContentView?: string | null;
  previousContentData?: any;
  restorePreviousContent: () => void;
}

export const DashboardProvider: React.FC<DashboardProviderProps> = ({ 
  children, 
  updateContent,
  contentView,
  contentData,
  previousContentView,
  previousContentData,
  restorePreviousContent,
}) => {
  return (
    <DashboardContext.Provider value={{ updateContent, contentView, contentData, previousContentView, previousContentData, restorePreviousContent }}>
      {children}
    </DashboardContext.Provider>
  );
};